module.exports = __webpack_public_path__ + "img/icon-admin-light.c69f3c12.svg";